import React, { useEffect, useState } from 'react';
import { Rating } from '@mui/material';
import { useTheme } from "../UI/Theme/ThemeContext";
import { ButtonSubmitGreen } from '../UI/Buttons/Buttons';

const RoadmapPreview = ({ roadmap, seniority }) => {
  const { themeName } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 700);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (!roadmap) return null;

  console.log(roadmap)
  // roadmap might be passed the blueprint directly or an object containing blueprint
  const blueprint = roadmap.blueprint || {};
  const careerTitle = blueprint.careerTitle || roadmap.jobPosition || roadmap.careerTitle || '';
  const whyThisPath = blueprint.whyThisPath || roadmap.whyThisPath || roadmap.motivation || '';
  const overallWeeks = blueprint.overallDurationWeeks || roadmap.overallDurationWeeks || 0;
  const phases = Array.isArray(blueprint.phases) ? blueprint.phases : Array.isArray(roadmap.phases) ? roadmap.phases : [];
  const numPhases = phases.length;
  const level = seniority || 0;
  const highlights = blueprint.topSkills || roadmap.topSkills || [];

  const container = {
    width: '100%',
    borderRadius: 14,
    padding: '14px',
    boxSizing: 'border-box',
    background: themeName === 'dark' ? 'linear-gradient(135deg, rgba(7,12,35,0.48), rgba(0,0,0,0.2))' : 'linear-gradient(135deg, rgba(14,84,86,0.06), rgba(255,244,224,0.6))',
    border: themeName === 'dark' ? '1px solid rgba(126,240,255,0.12)' : '1px solid rgba(238,123,28,0.12)',
    boxShadow: '0 6px 20px rgba(62,143,147,0.06)',
    display: 'flex',
    gap: 16,
    alignItems: 'flex-start',
    flexDirection: isMobile ? 'column' : 'row'
  };

  const left = { flex: 1 };
  // keep right column content left-aligned so Level, duration and phases start at same x offset
  const right = { width: isMobile ? '100%' : 220, display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start' };

  

  const formatDuration = (weeks) => {
    if (!weeks || weeks <= 0) return '—';
    const months = Math.round(weeks / 4.345);
    if (months < 2) return `${weeks} wk${weeks > 1 ? 's' : ''}`;
    return `${months} mo${months > 1 ? 's' : ''} (~${weeks} wks)`;
  };

  return (
    <div style={container} data-test="roadmap-preview-block">
      <div style={left}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div>
            <div style={{ fontSize: isMobile ? '1.05rem' : '1.15rem', textAlign: 'center', fontWeight: 900, color: themeName === 'dark' ? '#9BE9FF' : '#053f3f' }}>🚀 Your New Career Roadmap is ready!</div>
            <div style={{ marginTop: 8, fontSize: '.9rem', color: themeName === 'dark' ? '#cfeffd' : '#23525a' }}>
              Bubble Ai analyzed your resume, interests and the changing future of work, then designed an actionable, AI‑resilient career path with phases, personalized videos, milestones and recommended job-assured certifications so you can easily, quickly and confidently level up to grab that dream job in the shortest time.
            </div>
            <div style={{ marginTop: 10 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
                <div style={{ fontSize: isMobile ? '.9rem' : '.95rem', fontWeight: 800, color: themeName === 'dark' ? '#FFDFB5' : '#EE7B1C' }}>Career Title:</div>
                <div style={{ fontSize: isMobile ? '1rem' : '1.05rem', fontWeight: 800, color: themeName === 'dark' ? '#E6FBFF' : '#053f3f' }}>{careerTitle || 'Suggested Career Path'}</div>
              </div>
              {whyThisPath && <div style={{ marginTop: 6, fontSize: '.9rem', color: themeName === 'dark' ? '#cfeffd' : '#23525a' }}>{whyThisPath}</div>}
            </div>
          </div>
        </div>

        {highlights && highlights.length > 0 && (
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: '.85rem', fontWeight: 800, marginBottom: 8, color: themeName === 'dark' ? '#FFD9A8' : '#EE7B1C' }}>Top Skills Gained</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {highlights.slice(0, 6).map((h, i) => (
                <div key={i} style={{
                  padding: '6px 10px',
                  borderRadius: 999,
                  fontSize: '.82rem',
                  color: themeName === 'dark' ? '#2b1200' : '#07393a',
                  background: themeName === 'dark'
                    ? 'linear-gradient(90deg, #FF8A00 0%, #FFB86B 100%)'
                    : 'rgba(13,63,66,0.04)'
                }}>
                  {i === 0 ? '🔑' : i === 1 ? '⭐' : i === 2 ? '🎯' : '⚡'} &nbsp; {String(h).slice(0, 56)}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* brief bullets removed: snapshot moved to Level block on the right for compact layout */}
      </div>

      <div style={{ ...right, ...(isMobile ? {} : { borderLeft: themeName === 'dark' ? '1px solid rgba(255,255,255,0.03)' : '1px solid rgba(8,40,40,0.04)', paddingLeft: 12 }) }}>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'flex-start' }}>

          <div style={{ display: 'flex', gap: 12, alignItems: 'center', color: themeName === 'dark' ? '#cfeffd' : '#23525a', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ background: themeName === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(13,63,66,0.04)', borderRadius: 8, padding: '6px 8px' }}>📊</div>
              <Rating name="read-only" value={Number(level) || 0} readOnly precision={1} />
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ background: 'rgba(255,255,255,0.02)', borderRadius: 8, padding: '6px 8px' }}>📅</div>
              <div style={{ fontSize: '.9rem', fontWeight: 600 }}>{formatDuration(overallWeeks)}</div>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ background: 'rgba(255,255,255,0.02)', borderRadius: 8, padding: '6px 8px' }}>🧭</div>
              <div style={{ fontSize: '.9rem', fontWeight: 600 }}>{numPhases} phase{numPhases > 1 ? 's' : ''}</div>
            </div>
          </div>

          <div style={{ width: '100%', display: 'flex', gap: 8, justifyContent: isMobile ? 'flex-start' : 'flex-start' }}>
            <ButtonSubmitGreen onClick={() => { window.location.href = '/user/dashboard/career-roadmap'; }}>
              View Full Roadmap
            </ButtonSubmitGreen>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoadmapPreview;
